import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageHeader from '../../components/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import { adminApi } from '../../services/admin';

export default function AdminClientDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: client, isLoading } = useQuery({
    queryKey: ['admin', 'clients', id],
    queryFn: () => adminApi.getClient(id!),
    enabled: !!id,
  });

  if (isLoading) return <div className="flex justify-center py-12"><LoadingSpinner size="lg" /></div>;
  if (!client) return <div className="text-center py-12"><p className="text-sm text-slate-500">Client not found</p></div>;

  return (
    <>
      <PageHeader
        title={client.name}
        description="Client organization detail"
        actions={
          <button onClick={() => navigate('/admin/clients')} className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border-2 border-slate-200 rounded-xl hover:bg-slate-50">
            Back to Clients
          </button>
        }
      />
      <div className="rounded-2xl border border-slate-100 bg-white p-6">
        <h2 className="text-lg font-semibold text-slate-900 mb-4">Organization Info</h2>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
          {[
            ['Name', client.name],
            ['City', client.city || '—'],
            ['State', client.state || '—'],
            ['Phone', client.phone || '—'],
            ['Website', client.website || '—'],
            ['Members', String(client.member_count)],
            ['Created', new Date(client.created_at).toLocaleDateString()],
          ].map(([label, value]) => (
            <div key={label}>
              <dt className="text-xs font-medium text-slate-400 uppercase">{label}</dt>
              <dd className="mt-1 text-sm text-slate-900">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </>
  );
}
